// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Padlock = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 24 24"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4 2)">
        <path
          fill="#063755"
          d="M14.558 18.563a1.49 1.49 0 0 1-1.06.439l-10.992.01a1.503 1.503 0 0 1-1.5-1.499L1 8.009 14.991 8l.006 9.501c0 .402-.155.778-.439 1.062zM6 4.006C6 2.9 6.9 2 8.006 2c1.106 0 2.006.9 2.006 2.014l.023 2.989L6 7.006v-3zM15.991 7.5a.5.5 0 0 0-.5-.5l-3.455.002-.024-2.996A4.01 4.01 0 0 0 8.006 0 4.01 4.01 0 0 0 4 4.006v3.001l-3.5.002a.5.5 0 0 0-.5.501l.006 10.003a2.504 2.504 0 0 0 2.5 2.499l10.991-.01c.668 0 1.296-.259 1.77-.732a2.485 2.485 0 0 0 .73-1.769L15.991 7.5z"
          mask="url(#b)"
        />
      </g>
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
);
